exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dialog {\n  margin: 0;\n  padding: 0; }\n\n.dialog header {\n  background: #3d81f8; }\n\n.dialog header h1 {\n  text-transform: uppercase;\n  text-align: center;\n  margin: 0 auto;\n  padding: 15px 0 0 0;\n  color: #fff; }\n\n.dialog-content {\n  margin: 20px; }\n\n.check-message {\n  margin: 0 40px 20px 40px;\n  padding: 0; }\n\n.bt-dialog {\n  text-align: center;\n  padding: 10px 0 20px 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/dialog/dialog.component.scss
// module id = 1316
// module chunks = 0